import { h } from "preact";

import i18n from "../../i18n.js";
import { displayEuro } from "../../salaryHelper.js";
import { renderHtml } from "../../helpers.js";

export default function CostOfEmployment({ result, ...props }) {
  const annualCost = result.grossIncome + result.companyContributions.complete;

  return (
    <div class={props.class}>
      <p class="t-h5 color-brand-midnight">
        {i18n.t("pages.payroll_calculator.result.cost_of_employment.title")}
      </p>

      <p class="color-shades-charcoal mb-48 t-body2">
        {renderHtml(
          i18n.t(
            "pages.payroll_calculator.result.cost_of_employment.description",
            {
              salary: displayEuro(result.grossIncome),
            }
          )
        )}
      </p>

      <p class="t-body3 color-brand-midnight flex-spaced pb-24 bordered--bottom">
        <span>
          {i18n.t(
            "pages.payroll_calculator.result.cost_of_employment.annual_gross"
          )}
        </span>
        <span class={"page-title page-title--unpadded"}>
          {displayEuro(result.grossIncome)}
        </span>
      </p>

      <div class="t-caption color-shades-charcoal mt-40">
        {i18n.t("pages.payroll_calculator.result.social.label")}
      </div>
      <p class="t-body3 color-brand-midnight flex-spaced">
        <span>
          {i18n.t("pages.payroll_calculator.result.social.pension_insurance")}
        </span>
        <span>{displayEuro(result.companyContributions.pensionInsurance)}</span>
      </p>
      <p class="t-body3 color-brand-midnight flex-spaced">
        <span>
          {i18n.t(
            "pages.payroll_calculator.result.social.unemployment_insurance"
          )}
        </span>
        <span>
          {displayEuro(result.companyContributions.unemploymentInsurance)}
        </span>
      </p>
      <p class="t-body3 color-brand-midnight flex-spaced">
        <span>
          {i18n.t("pages.payroll_calculator.result.social.health_insurance")}
        </span>
        <span>{displayEuro(result.companyContributions.healthInsurance)}</span>
      </p>
      <p class="t-body3 color-brand-midnight flex-spaced pb-24 bordered--bottom">
        <span>
          {i18n.t(
            "pages.payroll_calculator.result.social.long_term_care_insurance"
          )}
        </span>
        <span>
          {displayEuro(result.companyContributions.longTermCareInsurance)}
        </span>
      </p>

      <p class="t-body3 color-brand-midnight flex-spaced mt-24">
        <span>
          {i18n.t(
            "pages.payroll_calculator.result.cost_of_employment.annual_cost"
          )}
        </span>
        <span class={"page-title page-title--unpadded"}>
          {displayEuro(annualCost)}
        </span>
      </p>
    </div>
  );
}
